// ThemeContext.js
import React, {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface CourseType {
  id: string;
  name: string;
}

interface Course {
  id: string;
  name: string;
  typeId: string;
}

interface ThemeContextType {
  isDarkMode: boolean;
  toggleTheme: () => void;
  setIsDarkMode: Dispatch<SetStateAction<boolean>>;
  courseTypes: CourseType[];
  setCourseTypes: Dispatch<SetStateAction<CourseType[]>>;
  courses: Course[];
  setCourses: Dispatch<SetStateAction<Course[]>>;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined
);

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [courseTypes, setCourseTypes] = useState<CourseType[]>([]);
  const [courses, setCourses] = useState<Course[]>([]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider
      value={{
        isDarkMode,
        toggleTheme,
        setIsDarkMode,
        courseTypes,
        setCourseTypes,
        courses,
        setCourses,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

// import React, { createContext, useState, ReactNode, useEffect } from 'react';

// interface ThemeContextType {
//   isDarkMode: boolean;
//   toggleTheme: () => void;
// }

// export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// const ThemeProvider = ({ children }: { children: ReactNode }) => {
//   const [isDarkMode, setIsDarkMode] = useState(() => {
//     const savedTheme = localStorage.getItem('isDarkMode');
//     return savedTheme ? JSON.parse(savedTheme) : false;
//   });

//   const toggleTheme = () => {
//     setIsDarkMode((prevMode: any) => {
//       const newMode = !prevMode;
//       localStorage.setItem('isDarkMode', JSON.stringify(newMode));
//       return newMode;
//     });
//   };

//   useEffect(() => {
//     document.body.classList.toggle('dark', isDarkMode);
//   }, [isDarkMode]);

//   return (
//     <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
//       {children}
//     </ThemeContext.Provider>
//   );
// };

// export default ThemeProvider;
